/**
 * mapActivityToShareTarget — normalizes event/activity data into an ActivityShareTarget.
 * Canonical data sources:
 *   - producer_events → title, type, dates, pricing, booking_mode
 *   - media_assets → cover image (via useCoverImageUrl)
 *   - producers → name, slug
 */

import type { ActivityShareTarget } from '../ShareTarget';

interface ActivityMapperInput {
  eventId: string;
  title: string;
  slug?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  timingMode?: string | null;
  isFree: boolean;
  priceOre: number;
  bookingMode: string;
  venueText?: string | null;
  descriptionHtml?: string | null;
  heroImageUrl?: string | null;
  producerName: string;
  producerSlug: string;
  producerId?: string | null;
}

export function mapActivityToShareTarget(input: ActivityMapperInput): ActivityShareTarget {
  return {
    type: 'activity',
    id: input.eventId,
    slug: input.slug ?? null,
    title: input.title,
    heroImageUrl: input.heroImageUrl ?? null,
    producerName: input.producerName,
    producerSlug: input.producerSlug,
    producerId: input.producerId ?? null,
    startDate: input.startDate ?? null,
    endDate: input.endDate ?? null,
    timingMode: input.timingMode ?? null,
    isFree: input.isFree,
    priceOre: input.priceOre,
    bookingMode: input.bookingMode,
    venueText: input.venueText ?? null,
    descriptionHtml: input.descriptionHtml ?? null,
  };
}
